import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "../../Icons";

import * as styles from "./Select.module.scss";

const DropdownMsg = ({ msg }) => (
	<span role="alert" className={cx("dropdown__msg")}>
		{msg}
	</span>
);

const Dropdown = forwardRef(
	(
		{
			label,
			labelHidden,
			onChange,
			onBlur,
			value,
			items,
			placeholder,
			full,
			size,
			className,
			helper,
			errorMsg,
			error,
			required,
			id,
			disabled,
		},
		ref
	) => {
		const classes = cx(styles.dropdown, {
			[styles[size]]: size && styles[size],
			[styles.full]: full,
			[styles.error]: error,
			[className]: className,
		});
		return (
			<div className={classes}>
				<label
					className={cx(styles.dropdown__label, {
						[styles.required]: required,
						[styles.hidden]: labelHidden,
					})}
					htmlFor={`select-${id}`}>
					{label}
				</label>
				<div className={styles.dropdown__content}>
					<select
						multiple={false}
						name={`select-${id}`}
						id={`select-${id}`}
						onChange={onChange}
						onBlur={onBlur}
						className={styles.dropdown__control}
						value={value}
						disabled={disabled}
						ref={ref}>
						{placeholder && (
							<option value={placeholder.value} disabled selected>
								{placeholder.label}
							</option>
						)}
						{items.map(item => (
							<option
								disabled={item.disabled}
								selected={value === item.value}
								key={`select-${id}-${item.value}`}
								value={item.value}>
								{item.label}
							</option>
						))}
					</select>
					<Icon name="arrow-down" className={styles.dropdown__arrow} />
				</div>
				{helper && !error && <DropdownMsg msg={helper} />}
				{error && <DropdownMsg msg={errorMsg} />}
			</div>
		);
	}
);

export default Dropdown;
export { Dropdown };

Dropdown.propTypes = {
	size: PropTypes.oneOf(["sm", "md", "lg"]),
	label: PropTypes.string.isRequired,
	labelHidden: PropTypes.bool,
	placeholder: PropTypes.shape({
		value: PropTypes.string,
		label: PropTypes.string,
	}),
	helper: PropTypes.string,
	errorMsg: PropTypes.string,
	error: PropTypes.bool,
	required: PropTypes.bool,
	full: PropTypes.bool,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	value: PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
	items: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })),
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
};

Dropdown.defaultProps = {
	size: "md",
	labelHidden: false,
	placeholder: { value: "", label: "Select" },
	helper: "",
	errorMsg: "",
	error: false,
	required: false,
	full: false,
	value: [],
	items: [],
	onChange: () => true,
	onBlur: () => true,
	className: "",
	disabled: false,
};

DropdownMsg.propTypes = {
	msg: PropTypes.string,
};

DropdownMsg.defaultProps = {
	msg: "",
};
